<ion-header>
  <ion-toolbar>
    <ion-title>Add CO2 to Tower</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card class="ion-no-padding">
    <ion-card-content class="ion-no-padding">
      <ion-list lines="full">
        @for (item of items(); track item.id) {
          <ion-item
            button
            (click)="selectCo2(item)"
            data-testid="co2-picker-item"
            [attr.data-co2-name]="item.name">
            <ion-icon name="cellular-outline" slot="start"></ion-icon>
            <ion-label>
              <h2>{{ item.name }}</h2>
            </ion-label>
          </ion-item>
        }

        @if (items().length === 0) {
          <ion-item>
            <ion-label>
              <h3>No available CO2 bottles</h3>
              <p>All CO2 bottles are already assigned to towers, or you don't have any yet.</p>
            </ion-label>
          </ion-item>
        }
      </ion-list>
    </ion-card-content>
  </ion-card>
</ion-content>
